import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

type CONSENT_KEYS = 'termsOfService' | 'privacyPolicy';

interface ConsentEntry {
	key: CONSENT_KEYS;
	granted: boolean;
	displayedText: string;
}

interface ConsentData {
	formUrl: string;
	locale: string;
	site: 'atlassian';
	action: 'FORM_FILL';
	source: 'JIRA';
	consents: ConsentEntry[];
}

const recordConsent = async (consents: ConsentEntry[], geoLocale: string) => {
	const url = '/gateway/api/consenthub/session/user';
	const consentData: ConsentData = {
		// This is the "page" that loaded consent.
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		formUrl: window.location.href,
		// This needs to be the geo corresponding to the user's IP, and must be determined on the backend
		locale: geoLocale,
		// always `atlassian`
		site: 'atlassian',
		// always `FORM_FILL` since this is in a web form
		action: 'FORM_FILL',
		// JIRA is defined in consenthub. This is the source of the consent.
		source: 'JIRA',
		consents,
	};
	// don't need request options
	await performPostRequest<ConsentData>(url, {
		body: JSON.stringify(consentData),
		headers: {
			'Content-Type': 'application/json',
		},
	});
};

export const recordTosAndPrivacyConsent = async ({
	tosPrivacyText,
	geoLocale = 'UNKNOWN',
}: {
	tosPrivacyText: string;
	geoLocale?: string;
}) => {
	await recordConsent(
		[
			{
				key: 'termsOfService',
				granted: true,
				displayedText: tosPrivacyText,
			},
			{
				key: 'privacyPolicy',
				granted: true,
				displayedText: tosPrivacyText,
			},
		],
		geoLocale,
	);
};
